export default {
    dateFormat(value) {
        const date = value.split(' ');
        let parts
        if (date) parts = date[0].split('-');
        else parts = value.split('-');

        const localDate = new Date(parts[0], parts[1] - 1, parts[2]);
        return localDate.toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    },
    isPdfPath (path) {
        const extension = path.split('.').pop().toLowerCase();
        return extension === 'pdf';
    },
    validatePayAmount (amount, orderPayInfo) {
        const remaining = orderPayInfo.max - orderPayInfo.paid
        if (amount < orderPayInfo.min && orderPayInfo.paid === 0) {
            return {
                isValid: false,
                alert: {
                    show: true,
                    message: `La cantidad minima a pagar es de $${orderPayInfo.min}`,
                    type: 'danger'
                }
            }
        }
        if (orderPayInfo.paid > 0 && amount < remaining) {
            return {
                isValid: false,
                alert: {
                    show: true,
                    message: `La cantidad minima a pagar es de $${remaining}`,
                    type: 'danger'
                }
            }
        }
        if (amount > remaining) {
            return {
                isValid: false,
                alert: {
                    show: true,
                    message: `La cantidad maxima a pagar es de $${remaining}`,
                    type: 'danger'
                }
            }
        }

        return {isValid: true}
    },
    getParcelImage(parcel) {
        switch (parcel) {
            case 'PAQUETEXPRESS PA':
            case 'PAQUETEXPRESS':
                return '/storage/img/paquetexpress.jpeg'
            case 'FEDEX':
            case 'FedEx':
                return '/storage/img/fedex.jpeg'
            case 'DHL Nacional':
            case 'DHL':
                return '/storage/img/dhl.jpeg'
            case 'TELOCRUZO':
                return '/storage/images/1746899207-telocruzo.png'
            case 'AFIMEX':
            case 'AFIMEX PA':
                return '/storage/img/afimex.jpeg'
            case 'SENDEX':
            case 'SENDEX PA':
                return '/storage/img/sendex.jpeg'
            default:
                return '/storage/img/estafeta.jpeg'
        }
    },
    getParcelLabel(parcel) {
        const hostname = window?.location?.hostname
        if (hostname === 'importaciones.huipixenvios.com.mx') {
            const normalized = parcel?.toUpperCase()
            switch (normalized) {
                case 'FEDEX':
                    return 'HUIPIX ESTANDAR'
                case 'PAQUETEXPRESS':
                case 'PAQUETEXPRESS PA':
                    return 'HUIPIX ECONOMY'
                case 'DHL':
                case 'DHL NACIONAL':
                    return 'HUIPIX EXPRESS'
                default:
                    return parcel
            }
        }
        return parcel
    },
    getMissingDays (date) {
        const today = new Date();
        const targetDate = new Date(date);

        // Elimina la parte de horas para que sea solo por día
        today.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);

        const diffTime = targetDate - today; // en milisegundos
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    },
    formatCurrency(value, locale = 'es-MX', currency = 'MXN') {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
        }).format(value);
    },
    shippingNumberFormat (guide) {
        if (!guide) return 'Guía no generada';
        if (!guide.shipping_number) return 'Sin número de envío';
        return guide.shipping_number
    },
    getLandingPageData (landing_page_data) {
        let webData = typeof landing_page_data === 'object' ? landing_page_data : JSON.parse(landing_page_data)

        if (!webData.how_do_it) {
            webData.how_do_it = {
                title: "¿Cómo lo hacemos?",
                description: '',
                visible: true,
                display_mode: 'steps',
                image_path: '',
                steps: []
            }
        } else {
            if (!Array.isArray(webData.how_do_it.steps)) webData.how_do_it.steps = []
            if (!webData.how_do_it.title) webData.how_do_it.title = "¿Cómo lo hacemos?"
            if (!webData.how_do_it.description) webData.how_do_it.description = ''
            if (typeof webData.how_do_it.visible !== 'boolean') webData.how_do_it.visible = true
            if (!webData.how_do_it.display_mode) webData.how_do_it.display_mode = 'steps'
            if (!webData.how_do_it.image_path) webData.how_do_it.image_path = ''
        }

        if (!['steps', 'image'].includes(webData.how_do_it.display_mode)) {
            webData.how_do_it.display_mode = 'steps'
        }
        if (!webData.hero) webData.hero = {
            title: "IMPORTAMOS TUS COMPRAS DE MERCANCIA DE USA",
            description: `Somos tu mejor opción No. 1 para cualquier empresa.
            
Lo hacemos facil y sencillo, somos tu opción más confiable.`,
            background_img: ''
        }

        if (!webData.frequently_asked_questions) webData.frequently_asked_questions = {
            title: "Preguntas frecuentes",
            description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure natus fugiat, accusantium laboriosam consequatur dolores ab eos excepturi provident quae culpa suscipit cumque incidunt eaque soluta ipsam, beatae voluptatum totam.',
            visible: true,
            questions: [
                {
                    ask: 'preguntaa',
                    answer: 'respuestaa'
                }
            ]
        }
        if (!webData.easy_fast_simple) webData.easy_fast_simple = {
            title: "Fácil, Rápido y sin complicaciones",
            description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit...",
            button_label: "Cotiza con nosotros",
            visible: true
        }
        if (!webData.contact_info) webData.contact_info = {
            company_address: '',
            phone_number: '',
            whatsapp: '',
            email: '',
            link_instagram: '',
            link_facebook: '',
            link_linkedin: ''
        }
        if (!webData.promotions) webData.promotions = {
            visible: true,
            title: null,
            description: null,
            promotions: []
        }
        if (!webData.top_products) webData.top_products = {
            visible: true,
            products: [],
            title: null,
            description: null
        }

        if (!webData.gallery) webData.gallery = {
            visible: true,
            images: []
        }

        if (!webData.quot_page) webData.quot_page = {
            title: 'Cotizador',
            description: '',
            subtitle: 'Peso y dimensiones',
            subtitle_description: ''
        }

        return webData
    },
    getFlagUrl(code) {
        return `https://flagcdn.com/24x18/${code.toLowerCase()}.png`;
    },
    getTypeBadgeByStatus (status) {
        if (status === 'Pagado' || status === 'Completado') return 'success'
        if (status === 'En Proceso') return 'warning'
        return 'info'
    },
}